/**
 * An invitation someone opened before they had an account.
 *
 * Sign-up goes through email confirmation and comes back to `/`, which would
 * send a brand-new user to onboarding to create a workspace of their own —
 * exactly wrong for the owner of a workspace a reseller already set up. The
 * root redirect resumes the invitation instead.
 */

const KEY = 'convo:pending-invite'

export function rememberPendingInvite(token: string): void {
  try {
    localStorage.setItem(KEY, token)
  } catch {
    /* Convenience only: the emailed link still works. */
  }
}

export function readPendingInvite(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function clearPendingInvite(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* Nothing to clear. */
  }
}
